// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Receipts_container__35Cg6{
    display: flex;
    min-height: calc(100vh - 280px);
    width: 566px;
    margin: 20px auto;
    padding: 5px 40px 65px 40px;
    left: 0;
    right: 0;
    background-color: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
@media(max-width: 730px){
    .Receipts_container__35Cg6{
        width: calc(100% - 80px);
    }
}
@media(max-width: 600px){
    .Receipts_container__35Cg6{
        min-height: calc(100vh - 260px);
        width: calc(100% - 40px);
        padding-left: 20px;
        padding-right: 20px;
    }
}
.Receipts_header__pvGNf{
    text-align: left;
    word-break: normal;
}
.Receipts_email__Zwoki{
    display: block !important;
    margin-top: 40px;
}
.Receipts_email__Zwoki input{
    width: calc(100% - 44px);
}
.Receipts_lastFour__-68Dl{
    margin-top: 25px;
}
.Receipts_bottomSection__9G5dk{
    margin-top: 55px;
}
.Receipts_apiError__H04h0{
    margin-top: -15px;
    margin-bottom: 20px;
}
.Receipts_button__UJ36F{
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    width: 261px;
}
.Receipts_bubbleCheckmark__9n6r\\+{
    display: block;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    height: 60px;
    width: 60px;
    margin-top: 30%;
}
@media(max-width: 900px){
    .Receipts_bubbleCheckmark__9n6r\\+{
        margin-top: 30px;
    }
}
.Receipts_requestedText__wekXD{
    margin-top: 40px;
    text-align: center;
    font-family: 'Gotham Bold', serif;
    font-size: 31px;
    line-height: 37px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Receipts.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,+BAA+B;QAC/B,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,cAAc;IACd,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".container{\n    display: flex;\n    min-height: calc(100vh - 280px);\n    width: 566px;\n    margin: 20px auto;\n    padding: 5px 40px 65px 40px;\n    left: 0;\n    right: 0;\n    background-color: #FFFFFF;\n    border-radius: 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n@media(max-width: 730px){\n    .container{\n        width: calc(100% - 80px);\n    }\n}\n@media(max-width: 600px){\n    .container{\n        min-height: calc(100vh - 260px);\n        width: calc(100% - 40px);\n        padding-left: 20px;\n        padding-right: 20px;\n    }\n}\n.header{\n    text-align: left;\n    word-break: normal;\n}\n.email{\n    display: block !important;\n    margin-top: 40px;\n}\n.email input{\n    width: calc(100% - 44px);\n}\n.lastFour{\n    margin-top: 25px;\n}\n.bottomSection{\n    margin-top: 55px;\n}\n.apiError{\n    margin-top: -15px;\n    margin-bottom: 20px;\n}\n.button{\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    width: 261px;\n}\n.bubbleCheckmark{\n    display: block;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    height: 60px;\n    width: 60px;\n    margin-top: 30%;\n}\n@media(max-width: 900px){\n    .bubbleCheckmark{\n        margin-top: 30px;\n    }\n}\n.requestedText{\n    margin-top: 40px;\n    text-align: center;\n    font-family: 'Gotham Bold', serif;\n    font-size: 31px;\n    line-height: 37px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Receipts_container__35Cg6`,
	"header": `Receipts_header__pvGNf`,
	"email": `Receipts_email__Zwoki`,
	"lastFour": `Receipts_lastFour__-68Dl`,
	"bottomSection": `Receipts_bottomSection__9G5dk`,
	"apiError": `Receipts_apiError__H04h0`,
	"button": `Receipts_button__UJ36F`,
	"bubbleCheckmark": `Receipts_bubbleCheckmark__9n6r+`,
	"requestedText": `Receipts_requestedText__wekXD`
};
export default ___CSS_LOADER_EXPORT___;
